import React from 'react';
import IntraDayDeals from './deals';
import SaleCallOut from './product-salecallout';
import ProductStatusBadge from './product-status-badge';
import ProductSegmentBadge from './product-segment-badge';
import '../css/product-card-header.less';

const ProductCardHeader = ({ product, intraDayMsg, saleCalloutPath }) => {
    return (
        <div className="prd-card-header">
            <div className="left-corner">
                <ProductStatusBadge product={product} />
                <ProductSegmentBadge product={product} size='small' />
            </div>
            <IntraDayDeals itemId={product.itemId}>
                {dealProps => {
                    const { isActive, productDeals, IntraDayBanner } = dealProps;
                    return isActive ? (
                        <IntraDayBanner
                            deals={productDeals}
                            message={product?.metadata?.intraDayMessage}
                            className="v2"
                            dateFormat="h:m:s"
                        />
                    ) : (
                        <SaleCallOut
                            product={product}
                            callout={saleCalloutPath ? product[saleCalloutPath] : null}
                            className="v2"
                        />
                    );
                }}
            </IntraDayDeals>
        </div>
    );
};

export default ProductCardHeader;
